import React from 'react';
import {BrowserRouter, Route} from "react-router-dom";
import * as routes from './constants/routes';
import Landing from "./routes/landing/Landing";
import Admin from "./routes/admin/Admin";
import Dashboard from "./routes/dashboard/Dashboard";

import FirebaseContext, {firebase} from './firebase/index';
import PrivacyPage from "./routes/privacy/Privacy";
import NavBar from "./components/NavBar";


function App() {

    return (
        <FirebaseContext.Provider value={firebase}>
            <BrowserRouter>
                <div>
                    <NavBar/>
                    <Route exact path={routes.landing} component={Landing}/>
                    <Route path={routes.privacy} component={PrivacyPage}/>
                    <Route path={routes.admin} component={Admin}/>
                    <Route path={routes.dashboard} component={Dashboard}/>
                </div>
            </BrowserRouter>
        </FirebaseContext.Provider>
    );
}

export default App;
